export default __webpack_public_path__ + "assets/images/f6bf193cc143516bd09b0bd6693527a0.svg";